import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8343je4q5y: FaireBrandEntity = {
  token: "b_8343je4q5y",
  type: "brand",
  name: "Snacky Candy",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc628d68e42f1d7a0bf8ea33fe7d63a9d9751ab6f70b5929f953c721842abf01.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/625e202eacbde7d794cacc6d62b56e35bae6d1c1c43570185a9a0b4370534578.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fc628d68e42f1d7a0bf8ea33fe7d63a9d9751ab6f70b5929f953c721842abf01.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/625e202eacbde7d794cacc6d62b56e35bae6d1c1c43570185a9a0b4370534578.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 400,
  rating: 4.6,
  reviewCount: 16,
  isInsider: true,
  description:
    "At Snacky Candy by SKA Nextgen, we specialize in wholesale bulk distribution of the world’s favorite chocolates and candies — from Kinder, Milka, and Nutella to American classics like Reese’s, Hershey’s, and Skittles.\n\nWith 600+ products and fast, reliable service, we help retailers stock shelves with high-demand brands at competitive prices. Whether you're a supermarket or a small shop, we're here to make your candy aisle irresistible.\n\nTop brands. Bulk value. Sweet results",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:00.764Z",
    importedBy: "entity-db-cli",
  },
};
